"use client";

import React, { useEffect, useState } from "react";
import "./reviews.css";

export default function ReviewsPage() {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTestimonials = async () => {
      const apiUrl = (process.env.NEXT_PUBLIC_API_URL || '').replace(/\/api\/?$/, '').replace(/\/$/, '') || "";
      try {
        const res = await fetch(`${apiUrl}/api/testimonial/public?limit=100`, {
          cache: "no-store",
        });
        if (!res.ok) throw new Error("Failed to fetch testimonials");
        const data = await res.json();
        if (data.success && data.data && data.data.testimonials && data.data.testimonials.length > 0) {
          const activeTestimonials = data.data.testimonials.filter(item => item.isActive !== false);
          setTestimonials(activeTestimonials);
        }
      } catch (error) {
        console.warn("Error fetching testimonials, using static fallback:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  // Refresh AOS after data loads so newly rendered cards animate correctly
  useEffect(() => {
    if (!loading) {
      // Small tick to let DOM update first
      const t = setTimeout(() => {
        import("aos").then((mod) => {
          const AOS = mod.default || mod;
          AOS.refreshHard();
        });
      }, 50);
      return () => clearTimeout(t);
    }
  }, [loading]);

  const metaTags = {
    title: "CodeQlik Reviews - Real Success Stories",
    description:
      "Read success stories and reviews from our clients and team members. Discover how CodeQlik delivers exceptional software solutions and creates impactful results.",
    keywords:
      "codeqlik reviews, software development reviews, it solutions reviews, client testimonials, success stories",
    image: "/assets/img/reviews-share.png",
    url: "https://codeqlik.com/reviews",
  };

  const getReviewTitle = (message) => {
    if (!message) return "Verified Review";
    const cleanMsg = message.replace(/^["'\s]+|["'\s]+$/g, "");
    const words = cleanMsg.split(/\s+/);
    if (words.length <= 5) return cleanMsg;
    return words.slice(0, 5).join(" ") + "...";
  };

  const formatMessage = (msg) => {
    if (!msg) return "";
    let clean = msg.trim();
    if (clean.startsWith('"') && clean.endsWith('"')) {
      return clean;
    }
    return `"${clean}"`;
  };

  const displayReviews = testimonials;

  return (
    <>
      <div className="container p-0">
        <div className="review-header fade-in-top">
          <h1>
            Read Client Reviews & <br />
            Real Success Stories
          </h1>
        </div>

        <div className="container">
          <div className="row g-4">
            {displayReviews.map((item, idx) => {
              const ratingVal = Math.min(5, Math.max(1, item.rating || 5));
              const starsStr = "★".repeat(ratingVal) + "☆".repeat(5 - ratingVal);
              const reviewTitle = item.title || getReviewTitle(item.message);
              
              return (
                <div
                  className="col-md-6 col-lg-6"
                  key={item._id || idx}
                  data-aos="fade-up"
                  data-aos-delay={(idx % 2 === 0 ? 100 : 200).toString()}
                >
                  <div className="review-card">
                    <div className="review-stars">{starsStr.split("").join(" ")}</div>
                    <div className="review-title">{reviewTitle}</div>
                    <div className="review-text">{formatMessage(item.message)}</div>
                    <div className="review-author">{item.name}</div>
                    {item.designation && <div className="review-role">{item.designation}</div>}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
